module.exports = __webpack_public_path__ + "assets/4e241219cb35e7f5fc6a41e42248d1dd.woff2";